import { IPageState } from '../../types/page';

const initialState: IPageState = {
  deviceType: 'desktop' as 'desktop',
};

export function pageReducer(state = initialState) {
  return state;
}
